import findIndex from 'lodash/findIndex.js';

import Model from '@/models/Model.js';

export default class GradebookPreview extends Model {
    static entity = 'gradebook-preview';

    static fields() {
        return {
            id: this.attr(null),
            week_activities: this.attr(null),
            activities: this.attr(null),
        };
    }

    static addGradebookPreviewMenu(user, items, hasGradableActivity) {
        const courseDashboardIndex = findIndex(items, item => item.type === 'course-dashboard');

        const gradebookPreviewIndex = findIndex(items, item => item.type === 'gradebook-preview');

        const isCourseTemplate = courseDashboardIndex < 0;

        const courseId = items[0].course_id;

        const isStudentSupport = !isCourseTemplate && user.isGroupStudentSupportOf(courseId);

        const isStudent = !isCourseTemplate && user.isStudentOf(courseId);

        if (gradebookPreviewIndex < 0 && hasGradableActivity && !isStudentSupport && !isStudent) {
            const gradebookPreview = {
                course_id: courseId,
                hint: 'Gradebook Preview',
                title: 'Gradebook Preview',
                type: 'gradebook-preview',
                permission: {
                    action: 'view',
                    subject: 'gradebook preview',
                    name: 'view a gradebook preview',
                },
            };

            items.splice(isCourseTemplate ? 0 : courseDashboardIndex + 1, 0, gradebookPreview);
        }

        return items;
    }
}
